import {
  Accordion,
  Dropdown,
  Header,
} from '@common/vanilla_ui/general';
import { detectIfTouchDevice } from '@common/utils/touch';

window.addEventListener('load', () => {
  detectIfTouchDevice();

  if (document.getElementById('dashboard-header')) {
    window.header = new Header('dashboard-header');
  }

  Accordion.initialize();
  Dropdown.initialize();
});
